/* Save Answers function */
window.saveAnswers = function () {
  window.dispatchEvent(new Event("ai-agent-save-chat"));
}

/* Misc functions */
const CONVERSATION_KEY = "ai_agent_conversationId";

function getConversationId() {
  let id = localStorage.getItem(CONVERSATION_KEY);
  if (!id) {
    id = generateGUID();
    setConversationId(id);
  }
  return id;
}

function setConversationId(id) {
  localStorage.setItem(CONVERSATION_KEY, id);
}

function resetConversationId() {
  const newId = generateGUID();
  setConversationId(newId);
  return newId;
}

function resetChat() {
  window.dispatchEvent(new CustomEvent("ai-agent-reset-chat", {}));
  const embedElement = document.getElementById("ai-agent-embed");
  if (embedElement) {
    const newId = resetConversationId();
    embedElement.setAttribute("conversationid", newId);
  }
}

function generateGUID() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
    /[xy]/g,
    function (c) {
      const r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    }
  );
}

window.generateGUID = generateGUID;
window.resetChat = resetChat;

document.addEventListener("DOMContentLoaded", function () {
  var embed = document.querySelector("ai-agent-embed");

  window.ai_agent_conversation_id = getConversationId();
  if (embed) {
    embed.setAttribute("conversationid", window.ai_agent_conversation_id);
  }
});